import { __awaiter, __generator } from "tslib";
export function importKey(jwk) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, window.crypto.subtle.importKey('jwk', jwk, 'AES-GCM', false, [
                    'encrypt',
                    'decrypt',
                ])];
        });
    });
}
//# sourceMappingURL=importKey.js.map